// extracted by mini-css-extract-plugin
export var colorSquare = "_os-0";
export var danger = "_os-5";
export var lightPink = "_os-8";
export var neutralBlue = "_os-7";
export var neutralYellow = "_os-6";
export var normal = "_os-1";
export var primary = "_os-2";
export var primaryLight = "_os-3";
export var solidBlack = "_os-g";
export var solidGreen = "_os-b";
export var solidLightBlue = "_os-d";
export var solidNavy = "_os-c";
export var solidOrange = "_os-f";
export var solidPink = "_os-e";
export var solidRed = "_os-9";
export var solidYellow = "_os-a";
export var success = "_os-4";